import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { FormGroup, InputGroup, Button, HTMLTable } from "@blueprintjs/core";
import { AxiosInstance } from 'axios';

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import { License, HardwareId } from './Types'
import * as utils from "./utils";

interface ConfirmEmailProps {
    reg: AxiosInstance,
    defaultEmail?: string,
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function ConfirmEmail({ reg, defaultEmail }: ConfirmEmailProps) {
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, reset, setValue } = useForm<License>()
    const history = useHistory()
    const [isSending, setIsSending] = useState(false)

    let query = useQuery();

    let email = defaultEmail;
    if (query.has('email')) {
        email = query.get('email') as string
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const onSubmit = async (lcn: License) => {
        if (lcn.email && lcn.email.length > 0 && lcn.code && lcn.code.length > 0) {
            onSave(lcn)
        } else {
            utils.showError(t('insufficient_data'))
        }
    }

    const onSave = async (lcn: License) => {
        try {
            const res = await reg.post('/verifyemail', lcn)
            //console.log(vch)
            utils.showSuccess(t('done'))
            history.push("/register")
        } catch (error) {
            utils.showError(error)
        }
    }

    const onResend = async (lcn: License) => {
        if (lcn.email && lcn.email.length > 0) {
            try {
                setIsSending(true)
                const res = await reg.post('/verifyresend', lcn)
                //console.log(vch)
                setIsSending(false)
                utils.showSuccess(t('sent'))
            } catch (error) {
                setIsSending(false)
                utils.showError(error)
            }
        } else {
            utils.showError(t('insufficient_data'))
        }
    }

    return (
        <>
            <div style={{fontSize: "21px", fontWeight: 700}}>{t('confirm_email')}</div>
            <div className="Spacing-V-16"></div>
            <form onKeyDown={handleHotkey}>
                <div className="Row">
                    <FormGroup className="Col-1-2" label={t('email')} labelFor="inputEmail">
                        <InputGroup id="inputEmail" name="email" defaultValue={email} readOnly={email ? true : false} inputRef={register} />
                    </FormGroup>
                    <Button className="Col-3-1 Button-LabeledFormGroup" icon="repeat" disabled={isSending} onClick={handleSubmit(onResend)}>{t('resend')}</Button>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-1" label={t('code')} labelFor="inputCode">
                        <InputGroup id="inputCode" name="code" inputRef={register} />
                    </FormGroup>
                </div>
                <div className="Spacing-V-16" />
                <div className="Row">
                    <Button className="Col-1-1" icon="confirm" disabled={isSending} onClick={handleSubmit(onSubmit)}>{t('confirm')}</Button>
                </div>
            </form>
        </>
    );
}

export default ConfirmEmail